import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
class WhitelistControls extends Component {
  static propTypes = {
    spotId: PropTypes.string,
    user: PropTypes.object,
    removeUser: PropTypes.func
  };

  static defaultProps = {};

  static displayName = 'WhitelistControls';

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  @autobind
  removeFromWhitelist() {
    const { user } = this.props;
    this.props.removeUser({ user });
  }

  render() {
    return (
      <div className="teammates-controls">
        <span className="remove-button" onClick={this.removeFromWhitelist}>
          Remove
        </span>
      </div>
    );
  }
}

export default WhitelistControls;
